import GpanelContactsLabelContactsGrid from './gpanel-label-contacts-grid';

export default function GpanelContactsLabelContactsGridPage() {
  return <GpanelContactsLabelContactsGrid />;
}
